// @flow
import styled, { css } from "styled-components";
import { withProps } from "recompose";

const searchBoxShared = css`
    display: block;
    padding: 10px 10px 10px 40px;
    border: 0;
    border-radius: 3px;
    background-color: hsla(0, 0%, 100%, 0.13);
    color: #fff;
    font-size: 15px;
    font-weight: 400;
    line-height: 1;
    box-sizing: border-box;
    font-family: Helvetica Neue, HelveticaNeue, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;

    position: absolute;
    top: 6px;

    &::-webkit-input-placeholder {
        color: #fff;
    }

    &:focus {
        color: #fff;
        outline: 0;
        border: none;
        -moz-outline-style: none;
        background-color: hsla(0, 0%, 100%, 0.2);
    }

    &:focus::-webkit-input-placeholder {
        opacity: 0;
    }
`;

export const Header = styled.div`
    background: rgba(0, 0, 0, 0.15);
    height: 50px;
    position: absolute;
    width: 100%;
    top: 0;
`;

export const HeaderContent = styled.div`
    color: #fff;
    line-height: 50px;
    vertical-align: middle;
    height: 50px;
    position: absolute;
    top: 0;
    width: 100%;
`;

export const HeaderText = styled.a`
    position: absolute;
    padding-left: 25px;
    fontweight: "bold";
    cursor: pointer;
    color: #fff;
    text-decoration: none;

    &:hover {
        color: #fff;
    }

    &:active {
        color: #fff;
        outline: 0;
        border: none;
        -moz-outline-style: none;
    }

    &:focus {
        color: #fff;
        outline: 0;
        border: none;
        -moz-outline-style: none;
    }
`;

export const SearchArea = styled.div``;

export const SearchBox = withProps({ type: "text" })(
    styled.input`
        ${searchBoxShared} left: 210px;
        right: 6px;
        width: auto;
    `
);

export const CdSearchBox = withProps({ type: "text" })(
    styled.input`
        ${searchBoxShared} left: 6px;
        right: 6px;
        width: auto;
    `
);

export const SearchResults = styled.div`
    z-index: 9;
    left: 210px;
    right: 6px;
    width: auto;
    position: absolute;
    top: 45px;
    background-color: rgba(255, 255, 255, 0.9);
    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14),
        0px 3px 14px 2px rgba(0, 0, 0, 0.12);
`;

export const CdSearchResults = SearchResults.extend`
    left: 6px;
    right: 6px;
    width: auto;
`;

export const SearchResult = styled.div`
    color: #757575;
    padding: 12px;
    font-size: 15px;
    font-weight: 400;
    line-height: 1;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;

    &:hover {
        background-color: #f2f2f2;
    }
`;

export const Link = styled.a`
    color: #fff;
    font-family: Helvetica Neue, HelveticaNeue, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;

    &:hover {
        color: #fff;
    }
`;

export const LoginLink = Link.extend`
    position: absolute;
    right: 100px;
`;

export const SignupLink = Link.extend`
    position: absolute;
    right: 25px;
`;



// WEBPACK FOOTER //
// ./src/header-view/styled.js